import NeutralToggle from "../../../components/neutralToggle/NeutralToggle";
import "./PlanSelectionFlag.css";

const PlanSelectionFlag = ({
  isSelected = false,
  onSelectPlan,
  isSaving = false,
  disabled = false,
}) => {
  const handleToggle = newState => {
    if (isSaving || disabled) {
      return;
    }

    if (onSelectPlan) {
      onSelectPlan(newState);
    }
  };

  return (
    <div className="Align-plan-selection-flag">
      <div className="Align-plan-selection-flag-wrapper">
        <div className="Align-plan-selection-text">Set as surgery plan</div>
        <div className="Align-plan-selection-toggle">
          <NeutralToggle
            isOn={isSelected}
            onToggle={handleToggle}
            disabled={isSaving || disabled}
            titlePosition="left-right"
            titleOff=""
            titleOn=""
            noTitle={true}
          />
        </div>
      </div>
    </div>
  );
};

export default PlanSelectionFlag;
